import { isEqual } from "lodash";
import { useState } from "react";

import { PositionWithoutActivityQuickFilter } from "./interfaces";

export const usePositionWithoutActivityQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<PositionWithoutActivityQuickFilter>({
    positionWithoutActivity: {
      daysWithoutActivity: null,
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof PositionWithoutActivityQuickFilter,
    value: PositionWithoutActivityQuickFilter["positionWithoutActivity"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    positionWithoutActivityQuickFilter: quickFilter,
    setPositionWithoutActivityQuickFilter: handleChangeQuickFilter,
  };
};
